import * as requestFromServer from "./Crud";
import {Slice, callTypes} from "./Slice";
import { NotificationManager } from "react-notifications";

const {actions} = Slice;

export const fetchList = queryParams => dispatch => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getList(queryParams)
    .then(response => {
      // console.log('rr',response.data)
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;      
      dispatch(actions.listFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchSingle = id => dispatch => {
  if (!id) {
    return dispatch(actions.singleItemFetched({ currencyForEdit: undefined }));
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getItemById(id)
    .then(response => {
      const item = response.data;
      dispatch(actions.singleItemFetched({ currencyForEdit: item }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteItem = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteItem(id)
    .then(response => {
      dispatch(actions.itemDeleted({ id }));
      NotificationManager.success('success', 'Data deleted successfully!');
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createItem = item => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createItem(item)
    .then(response => {
      const { item } = response.data;
      NotificationManager.success('success', 'Data saved successfully!');
      dispatch(actions.itemCreated({ item }));
      return true ;
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateItem = (item,id) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateItem(item,id)
    .then(() => {
      NotificationManager.success('success', 'Data saved successfully!');
      dispatch(actions.itemUpdated({ item }));
      return true ;
    })
    .catch(error => {
      // error.clientMessage = "Can't update item";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false ;
    });
};

export const updateItemsStatus = (item,id) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateItemsStatus(item,id)
    .then(() => {
      NotificationManager.success('success', 'Data saved successfully!');
      dispatch(actions.itemUpdated({ item }));
      return true ;
    })
    .catch(error => {
      // error.clientMessage = "Can't update item";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false ;
    });
};

 

export const uploadImage = (queryParams) => dispatch => {
  return requestFromServer
  .uploadImage(queryParams.img)
  .then(response => {
    console.log("response",response)
    const entities = response.data;      
    const imageField = queryParams.name;      
    dispatch(actions.imageUploaded({ entities, imageField }));
  })
  .catch(error => {
    const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
      NotificationManager.error(errMsg, 'Error');
    dispatch(actions.catchError({ error, callType: callTypes.list }));
  });
};
